import { z } from "zod";

export default {
  params: z.object({}),
  response: z.array(
    z.object({
      uid: z.string(),
      email: z.string(),
      createdAt: z.string(),
    }),
  ),
};
